/* eslint-disable */
export function toolTipPlacementCalculator(_a) {
  var dimension = _a.dimension,
    position = _a.position;
  if (position === 'top' || position === 'top-left') {
    return {
      bottom: dimension.bottomSpace + dimension.height + 30,
      left: dimension.leftSpace,
    };
  }
  if (position === 'top-right') {
    return {
      bottom: dimension.bottomSpace + dimension.height + 30,
      right: dimension.rightSpace,
    };
  }
  if (position === 'right') {
    return {
      left: dimension.width + dimension.leftSpace + 30,
      top: dimension.topSpace,
    };
  }
  if (position === 'left') {
    return {
      right: dimension.width + dimension.rightSpace + 30,
      top: dimension.topSpace,
    };
  }
  if (position === 'bottom-right') {
    return {
      top: dimension.height + dimension.topSpace + 30,
      right: dimension.rightSpace,
    };
  }
  return {
    top: dimension.height + dimension.topSpace + 30,
    left: dimension.leftSpace,
  };
}

export function dimensionSetter(_a) {
  var element = _a.element,
    setDimension = _a.setDimension;
  var rect = element.getBoundingClientRect();
  if (!rect) return;
  setDimension({
    height: rect.height,
    width: rect.width,
    leftSpace: rect.left - 5,
    rightSpace: window.innerWidth - rect.right - 5,
    topSpace: rect.top - 5,
    bottomSpace: window.innerHeight - rect.bottom - 5,
  });
}
